import React from 'react'
import { Field } from 'formik'
import Select from '../../_library/Select'
import { requiredValidator } from '../../../_common/core/validation'
import { ReactSelectField, SimpleField } from '../../formik/Fields'
import Button from '../../_library/Button'

const DelegationFormMobile = props => {
  const {
    index,
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    optionsTickets,
    emailTemplatesOptions,
    showDayTimeSelects,
    handleChangeTicketTypeID,
    removeTicketType,
  } = props

  return (
    <div className="guest-ticket-new-delegate-mobile">
      <Select
        options={optionsTickets}
        id={'types[' + index + '].ticketTypeId'}
        style={{ minWidth: '140px' }}
        value={
          showDayTimeSelects(values.types[index].selectedGroup)
            ? values.types[index].selectedGroup
            : values.types[index].ticketTypeId
        }
        error={
          showDayTimeSelects(values.types[index].selectedGroup)
            ? errors.types && errors.types[index] && errors.types[index].selectedGroup
            : errors.types && errors.types[index] && errors.types[index].ticketTypeId
        }
        touched={
          showDayTimeSelects(values.types[index].selectedGroup)
            ? touched.types && touched.types[index] && touched.types[index].selectedGroup
            : touched.types && touched.types[index] && touched.types[index].ticketTypeId
        }
        onChange={e => handleChangeTicketTypeID(e, index)}
        onBlur={handleBlur}
      />
      <Field
        name={'types[' + index + '].isGuestTicket'}
        id={'types[' + index + '].isGuestTicket'}
        // style={{ minWidth: '140px' }}
        onChange={handleChange}
        onBlur={handleBlur}
        component={ReactSelectField}
        options={[
          { value: 1, label: 'Guest Ticket' },
          { value: 0, label: 'Invitation' },
        ]}
        validate={requiredValidator()}
      />
      <Field
        type="number"
        name={'types[' + index + '].maxQuantity'}
        onChange={handleChange}
        onBlur={handleBlur}
        component={SimpleField}
      />
      <Field
        name={'types[' + index + '].invitationTemplateId'}
        id={'types[' + index + '].invitationTemplateId'}
        onChange={handleChange}
        component={ReactSelectField}
        options={emailTemplatesOptions}
        validate={requiredValidator()}
        disabled={Number(values.types[index].isGuestTicket) === 1}
        style={{
          opacity: Number(values.types[index].isGuestTicket) === 1 ? 0.5 : 1,
          minWidth: '190px',
        }}
      />
      <Button
        className="btn btn-danger btn-shadow new-delegation-delete-type-btn"
        type="button"
        style={{ minWidth: '20px' }}
        onClick={() => removeTicketType(index)}
      >
        <i className="fa fa-trash" />
      </Button>
    </div>
  )
}

export default DelegationFormMobile
